import { render, staticRenderFns } from "./UserChallenges.vue?vue&type=template&id=13905cb2&scoped=true&"
import script from "./UserChallenges.vue?vue&type=script&lang=js&"
export * from "./UserChallenges.vue?vue&type=script&lang=js&"
import style0 from "./UserChallenges.vue?vue&type=style&index=0&id=13905cb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13905cb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
